export default __webpack_public_path__ + "static/media/uv22_en_jing_b3.4c54dafc.mp3";